"use client";

import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

const FAQ: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "Do I need video editing experience?",
      answer:
        "No. If you can write basic React/JSX, you can follow this guide. Remotion is code-first — no timeline scrubbing required.",
    },
    {
      question: "Do I need a paid Claude subscription?",
      answer:
        "A free Claude account works for most examples. For longer compositions, a Pro plan helps but isn't required to get started.",
    },
    {
      question: "What if I've never used Remotion before?",
      answer:
        "Perfect — this guide starts from setup and walks you through your first render step by step.",
    },
    {
      question: "How is the PDF delivered?",
      answer:
        "Click the download button and the PDF opens instantly. No email, no payment, no waiting.",
    },
    {
      question: "Can I use this for client work or my SaaS?",
      answer:
        "Absolutely. The templates and workflows are yours to use however you want.",
    },
    {
      question: "What's the newsletter about?",
      answer:
        "Indie hacking, building in public, SaaS launches, and practical tutorials — the same stuff I write about while building PeerQuik and other projects.",
    },
  ];

  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
          FAQ
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-lg border border-cyan-400/20"
            >
              <button
                onClick={() =>
                  setExpandedIndex(expandedIndex === index ? null : index)
                }
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="font-semibold text-lg pr-4">
                  {faq.question}
                </span>
                {expandedIndex === index ? (
                  <ChevronUp className="text-cyan-400 flex-shrink-0" />
                ) : (
                  <ChevronDown className="text-cyan-400 flex-shrink-0" />
                )}
              </button>
              {expandedIndex === index && (
                <div className="px-6 pb-6 text-gray-300">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
